import { RegisterEntranceService } from './../../dialog/register-entrance/service/register-entrance.service';
import { EntranceRegistration } from './../../dialog/register-entrance/model/out/entrance-registration';
import { CheckState } from './../../dialog/register-entrance/model/CheckState.enum';
import { Check } from './../../dialog/register-entrance/model/Check';
import { WeighingType } from './../../dialog/register-entrance/model/weighing-type.enum';
import { Transport } from './../../dialog/register-entrance/model/Transport';
import { forkJoin } from 'rxjs';
import { ResponseMessage } from '@sdbn/appclient';
import { ResponseStatus } from '@sdbn/appclient';
import { ParamterType } from '@sdbn/appclient';
import { SupplementaryEquipment } from '@sdbn/appclient';
import { SupplementaryEquipmentHandoutService } from '@sdbn/appclient';
import { TMCClientParameters } from 'src/tmc-common/tmc-client-parameters';
import { Transport as SeTransport } from '@sdbn/appclient';
import { ViewChild } from '@angular/core';
import { NgForm, NgModel } from '@angular/forms';
import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ConfigurationService } from '@sdbn/appclient';
import { AutoWeighingService } from 'src/tmc-yard/legacy/auto-weighing/auto-weighing.service';
import { TranslationService } from '@sdbn/common';


export interface RegisterEntranceCombinedDialogData {
  transportId: number;
  callback: () => void;
}

@Component({
  selector: 'app-register-entrance-combined',
  templateUrl: './register-entrance-combined.component.html',
  styleUrls: ['./register-entrance-combined.component.scss']
})
export class RegisterEntranceCombinedComponent implements OnInit {

  @ViewChild('weighForm') weighForm: NgForm;

  transport = new Transport();
  seTransport = new SeTransport();
  isLoading = false;

  clientParameters = TMCClientParameters;
  typeOptions: WeighingType[] = [];

  responseMessages: ResponseMessage[];

  constructor(
    public dialogRef: MatDialogRef<RegisterEntranceCombinedComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RegisterEntranceCombinedDialogData,
    private entranceService: RegisterEntranceService,
    private seService: SupplementaryEquipmentHandoutService,
    public cps: ConfigurationService,
    public translationService: TranslationService,
    private autoWeighingService: AutoWeighingService) {

    for (const t of Object.keys(WeighingType)) {
      this.typeOptions.push(WeighingType[t]);
    }
  }

  ngOnInit() {
    this.isLoading = true;

    forkJoin(
      [this.seService.getTransport({ id: this.data.transportId }),
      this.entranceService.getTransport({ id: this.data.transportId })]
    ).subscribe(results => {
      this.seTransport = results[0];
      this.transport = results[1];
      this.transport.autoWeightSource = this.cps.getClientParamValue('ui-component.register-entrance.weighing.auto.source', null);

      if (this.transport.autoWeightSource != null && this.transport.autoWeightSource.length === 0) {
        this.transport.autoWeightSource = null;
      }

      this.isLoading = false;
      const defaultType = this.cps.getClientParamValue('ui-component.register-entrance.weighing.defaultType', null);
      if (defaultType != null && defaultType.length > 0) {
        this.transport.weighingType = WeighingType[defaultType];
      }

    }, error => {
      console.error(error);
      this.dialogRef.close({ status: 'failed' });
      this.isLoading = false;
    });

  }

  isStringParameter(se: SupplementaryEquipment) {
    return se.parameter1Type === ParamterType.STRING;
  }

  isNumberParameter(se: SupplementaryEquipment) {
    return se.parameter1Type === ParamterType.NUMBER;
  }

  cancelDialog(): void {
    this.dialogRef.close({ status: 'cancelled' });
  }

  isOk(check: Check) {
    return check.state === CheckState.OK;
  }

  isWarning(check: Check) {
    return check.state === CheckState.WARN;
  }

  isFailed(check: Check) {
    return check.state === CheckState.FAILED;
  }

  isInfo(check: Check) {
    return check.state === CheckState.INFO;
  }

  checksExist(transport: Transport): boolean {
    return transport != null && transport.checks != null && transport.checks.length > 0;
  }

  cancel() {
    this.dialogRef.close({ status: 'cancelled' });
  }

  decline() {
    this.isLoading = true;

    const er = new EntranceRegistration();
    er.transportId = this.transport.id;
    er.weighingType = this.transport.weighingType;
    er.weight = this.transport.weight;

    this.entranceService.decline(er).subscribe(
      response => {
        this.dialogRef.close({ status: 'success' });
        this.data.callback();
        this.isLoading = false;
      }, error => {
        console.error(error);
        this.isLoading = false;
      }
    );
  }

  isDeclineDisabled() {
    if (this.isLoading) {
      return true;
    }

    return false;
  }

  accept() {
    this.isLoading = true;

    this.seService.saveTransport(this.seTransport).subscribe(seResponse => {

      // if SE request succeeds
      if (seResponse.status === ResponseStatus.SUCCESS) {
        // execute checkin
        const er = new EntranceRegistration();
        er.transportId = this.transport.id;
        er.weighingType = this.transport.weighingType;
        er.weight = this.transport.weight;
        er.autoWeightSource = this.transport.autoWeightSource;
        er.autoWeight = this.transport.autoWeight;
        this.entranceService.accept(er).subscribe(
          result => {
            this.dialogRef.close({ status: 'success' });
            this.data.callback();
            this.isLoading = false;
          }, error => {
            console.error(error);
            this.isLoading = false;
          }
        );

      } else {
        // show error messages if SE request fails
        this.responseMessages = seResponse.responseMessages;
      }
      this.isLoading = false;
    }, error => {
      this.isLoading = false;
      console.log(error);
    });
  }

  isNoSupplementaryEquipmentHandoutDisabled(): boolean {

    if (this.isLoading) {
      return true;
    }

    if (this.seTransport.supplementaryEquipmentHandoutHappened === true) {
      return true;
    }
    if (this.seTransport.supplementaryEquipments != null &&
      this.seTransport.supplementaryEquipments.length > 0 && this.seTransport.supplementaryEquipments.some(se => se.selected)) {
      return true;
    }
    return false;
  }

  isFormReadonly() {
    return this.isLoading;
  }

  isNoSupplementaryEquipmentHandoutSelected(): boolean {
    return this.seTransport.noSupplementaryEquipmentHandout === true;
  }

  isAcceptDisabled() {
    if (this.isLoading) {
      return true;
    }

    if (!this.transport.allowEntrance) {
      return true;
    }

    // es darf nur geprüft werden, wenn das feature aktiv ist!
    if (this.isWeighingActive()) {
      if (this.weighForm && (this.weighForm.invalid || !this.transport.weighingType)) {
        return true;
      }
    }

    // wenn keine "Bestätigung Begleitmittel nötig" konfiguriert
    if (!this.cps.isEnabled(TMCClientParameters.FEATURE_FORCE_SUPPLEMENTARY_EQUIPMENT_CONFIRMATION, true)) {
      // prüfung auf eingabe ungültiger werte
      for (const se of this.seTransport.supplementaryEquipments) {
        if (se.selected) {
          if (se.parameter1Type !== ParamterType.NONE && (se.parameter1Value == null || se.parameter1Value.length === 0)) {
            return true;
          }
        }
      }

      return false;
    }

    // SE nur prüfen wenn flag nicht gesetzt und noch kein SE ausgegeben
    if (!this.seTransport.noSupplementaryEquipmentHandout &&
      !this.seTransport.supplementaryEquipmentHandoutHappened) {
      // kein check, wenn es keine SE gibt
      if (this.seTransport.supplementaryEquipments.length === 0) {
        return false;
      }

      let validCount = 0;
      for (const se of this.seTransport.supplementaryEquipments) {
        if (se.selected) {
          if (se.parameter1Type !== ParamterType.NONE && (se.parameter1Value == null || se.parameter1Value.length === 0)) {
            return true;
          } else {
            validCount += 1;
          }
        }
      }
      return validCount === 0;
    }
    return false;
  }

  isWeighingTypeRequired(): boolean {
    return this.transport.weight != null && this.transport.weight > 0;
  }

  descriptionExists(check: Check) {
    if (!check.descriptionDictionaryKey) {
      return false;
    }
    const description: string = this.translationService.translate(check.descriptionDictionaryKey);
    return description.length > 0;
  }

  showValuePositiveIntegerError(ctrl: NgModel) {
    return ctrl.touched && ctrl.hasError('positiveInteger');
  }

  getRowOffset(): number {
    return this.cps.isEnabled(this.clientParameters.FEATURE_FORCE_SUPPLEMENTARY_EQUIPMENT_CONFIRMATION, true) ? 2 : 1;
  }

  public isWeighingActive(): boolean {
    return this.cps.isEnabled(TMCClientParameters.UI_COMPONENT_REGISTER_ENTRANCE_WEIGHING_ENABLED, true) &&
      this.cps.isEnabled(TMCClientParameters.P_VISITS_WEIGHING_ENABLED, true);
  }

  public readWeight() {

    this.autoWeighingService.readWeight(this.transport.autoWeightSource).subscribe(result => {
      this.transport.autoWeight = result.weight;
      this.transport.weight = this.transport.autoWeight;
    });

  }

  public isAutoWeighingVisible(): boolean {
    return this.transport != null && this.transport.autoWeightSource != null && this.transport.autoWeightSource.length > 0;
  }
}
